import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import Clock from './Clock';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Clock />
);
